import { FormTypography } from "@/forms-design-system/FormTypography";

export type DrawerTitleProps = {
  id?: string;
  children: string;
};

export const DrawerTitle = ({ id, children }: DrawerTitleProps) => {
  return (
    <FormTypography id={id} variant="h5" fontWeight={600} vibe="intense" data-test="drawer-title">
      {children}
    </FormTypography>
  );
};
